import Vue from 'vue';
export default Vue.extend({
  methods: {
    t(label: string): string {
      const $te: any = (this as any).$te.bind(this);
      const $t: any = (this as any).$t.bind(this);
      return $te(label) ? $t(label) : undefined;
    },
  }
});
